import { render } from "./Pause.vue?vue&type=template&id=8eefbefe"
import script from "./Pause.vue?vue&type=script&lang=js"
export * from "./Pause.vue?vue&type=script&lang=js"
script.render = render

export default script